import {
  LOAD_DOCUMENT_LIST,
  LOAD_DOCUMENT_LIST_SUCCESS,
  LOAD_DOCUMENT_LIST_ERROR,
  RESET_DOCUMENT_LIST,
} from '../type';
import update from 'immutability-helper';

import { handleActions } from 'redux-actions';

export const initialState = {
  loadingStatus: {
    documentListLoading: false,
  },
  error: '',
  documentList: [],
};

const consultationReducer = handleActions(
  new Map([
    [
      LOAD_DOCUMENT_LIST,
      state => {
        return update(state, {
          loadingStatus: {
            documentListLoading: { $set: true },
          },
        });
      },
    ],
    [
      LOAD_DOCUMENT_LIST_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            documentListLoading: { $set: false },
          },
          documentList: {
            $set: action.payload,
          },
        });
      },
    ],
    [
      LOAD_DOCUMENT_LIST_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            documentListLoading: { $set: false },
          },
          error: { $set: action.payload },
        });
      },
    ],
    [
      RESET_DOCUMENT_LIST,
      (state, action) => {
        return update(state, {
          documentList: {
            $set: [],
          },
        });
      },
    ],
  ]),
  initialState,
);
export default consultationReducer;
